import { render, staticRenderFns } from "./burgerMenu.vue?vue&type=template&id=6637c5ec&scoped=true&"
import script from "./burgerMenu.vue?vue&type=script&lang=js&"
export * from "./burgerMenu.vue?vue&type=script&lang=js&"
import style0 from "./burgerMenu.vue?vue&type=style&index=0&id=6637c5ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6637c5ec",
  null
  
)

export default component.exports